import { Actions } from '../../interfaces'

import find from './find'
import { Expense } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { Expense },
  actions: { [Expense.name]: actions },
}
